// extracted by mini-css-extract-plugin
export default {"cls1":"JanqTWMaFnrrqTQ3uWYW","cls2":"rLfIPsUQ9IueWmqQ88Ig JanqTWMaFnrrqTQ3uWYW","bookingAppRedesign":"_vIYKLYjgHpTqoDjSqoR"};